import React from 'react'
import {Text, TYPOGRAPHY} from 'wix-ui-tpa/Text'
import {classes} from './description.st.css'

export const Description = props => <Text typography={TYPOGRAPHY.runningText} {...props} className={classes.root} />
